
import { Options, Vue } from 'vue-class-component';
import AltaDoctor from '@/components/doctores/AltaDoctor.vue';// @ is an alias to /src
import { isCurrentUserExist } from '@/firebase/auth/authServices';


@Options({
    components: {
        AltaDoctor,
    },
})
export default class PacientesView extends Vue {
    beforeCreate(): void {
      isCurrentUserExist();
  }
}
